// service/crm/hooks/useUpdateContactImportMappingMutation.ts

import { useMutation } from "@tanstack/react-query";
import { contactImportApi } from "service/crm/api/contactImport";
import {
  ContactImportFieldMap,
  ContactImportRecord,
} from "types/crm/contactImport";

interface UpdateMappingVariables {
  importUuid: string;
  columnMapping: ContactImportFieldMap;
}

/**
 * Saves the Map Fields step's column mapping.
 *
 * The import that comes back carries the columns, dropdown values and Owner /
 * Company matches the next step works from, so callers keep the result.
 */
export const useUpdateContactImportMappingMutation = () =>
  useMutation<ContactImportRecord, unknown, UpdateMappingVariables>({
    mutationFn: ({ importUuid, columnMapping }) =>
      contactImportApi.updateMapping(importUuid, { columnMapping }),
  });
